<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :after-save="afterSave"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section>
        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Field_Active')"
              prop="active"
            >
              <rest-form-select-boolean v-model="model.active" />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Field_GUID')"
              prop="kochava_app_guid"
            >
              <el-input
                v-model="model.kochava_app_guid"
                :placeholder="$t('Attribution_Field_GUID')"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Form_API')"
              prop="kochava_key"
            >
              <el-input
                v-model="model.kochava_key"
                :placeholder="$t('Attribution_Form_API')"
              />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Field_AppId')"
              prop="kochava_app_id"
            >
              <el-input
                v-model="model.kochava_app_id"
                :placeholder="$t('Attribution_Field_AppId')"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Form_CreateApp')"
              prop="kochava_do_create_app"
            >
              <rest-form-select-boolean v-model="model.kochava_do_create_app" />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Field_CampaignId')"
              prop="kochava_campaign_id"
            >
              <el-input
                v-model="model.kochava_campaign_id"
                :placeholder="$t('Attribution_Field_CampaignId')"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Form_CreateCampaign')"
              prop="kochava_do_create_campaign"
            >
              <rest-form-select-boolean
                v-model="model.kochava_do_create_campaign"
              />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              :label="$t('Attribution_Field_TierId')"
              prop="kochava_tier_id"
            >
              <el-input
                v-model="model.kochava_tier_id"
                :placeholder="$t('Attribution_Field_TierId')"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import RestFormSelectBoolean from '@/common/components/rest/RestFormSelectBoolean'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'AttributionFormPage',

  components: {
    RestFormPage,
    RestFormItem,
    FormSection,
    RestFormSelectBoolean
  },

  data() {
    return {
      model: {
        id: null,
        project_id: null,
        kochava_tier_id: null,
        kochava_campaign_id: null,
        kochava_app_id: null,
        kochava_key: null,
        kochava_app_guid: null,
        active: 0,
        kochava_do_create_campaign: 0,
        kochava_do_create_app: 0,
        platform: this.platform
      }
    }
  },

  props: {
    platform: {
      type: String,
      required: true
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `kochava-apps`,
        params: {
          platform: this.platform
        },
        handler: data => {
          Object.assign(this.model, data[0])
          this.model.project_id = this.$route.query.project_id
        }
      })
    },

    saveEndpoint() {
      if (this.model.id !== null) {
        return projectEndpoint({
          method: 'patch',
          url: `kochava-apps/${this.model.id}`
        })
      } else {
        return projectEndpoint({
          method: 'post',
          url: `kochava-apps`
        })
      }
    },

    readonly() {
      return !(this.$isRole('admin') || this.$isRole('provider-admin'))
    }
  },

  methods: {
    afterSave() {
      this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/attribution/pages/AttributionFormPage.vue